import { Button } from "PFComponents/button";
import { LoadingDots } from "PFComponents/loading_dots";
import { isProfileActive } from "PFCore/helpers/profile";
import useAddShortlist from "PFCore/hooks/use_add_shortlist";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useActivityShowContext } from "../context/activity_show_context";
import { useActivityShortlists } from "../hooks/use_activity_shortlists";

type Props = {
  profile: { id: number };
  onClick?: () => void;
  named?: boolean;
};

const AddShortlistButton = ({ profile, onClick, named }: Props) => {
  const { activityId } = useActivityShowContext();
  const { shortlists } = useActivityShortlists();
  const { shortlistProfile, undoShortlist, loading, isShortlisted, isShortlistsLoaded } = useAddShortlist(
    profile.id,
    activityId,
    shortlists,
    named
  );
  const { t } = useTranslation("activities", { keyPrefix: "show.parts" });

  const getButtonContent = useMemo(() => {
    if (loading) {
      return <LoadingDots />;
    }
    return isShortlisted ? t("shortlisted") : t("shortlist");
  }, [t, loading, isShortlisted]);

  if (!isProfileActive(profile)) {
    return null;
  }

  if (!isShortlistsLoaded) {
    return <LoadingDots />;
  }

  const handleClick = () => {
    if (isShortlisted) {
      undoShortlist({ onSuccess: onClick });
    } else {
      shortlistProfile({ onSuccess: onClick });
    }
  };

  const buttonKind = isShortlisted ? "primary" : "secondary";

  return (
    <Button disabled={loading} kind={buttonKind} onClick={handleClick} style={{ minWidth: 100 }}>
      {getButtonContent}
    </Button>
  );
};

export default AddShortlistButton;
